module.exports = __webpack_public_path__ + "img/google-play-badge.d14419ba.png";